(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumExpedienteController', ConsortiumExpedienteController);

        ConsortiumExpedienteController.$inject = ['DateUtils', '$state', 'ConsortiumExpediente', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','steps', 'status', '$mdSidenav', 'Principal'];

    function ConsortiumExpedienteController (DateUtils, $state, ConsortiumExpediente, ParseLinks, AlertService, paginationConstants, pagingParams, steps, status, $mdSidenav, Principal) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumExpedienteParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        vm.status = status;
        vm.steps = steps;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumExpedienteParameters', JSON.stringify(vm.searchItem));

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.id;
            }

            ConsortiumExpediente.query({
                code: vm.searchItem.code,
                status: idStatus,
                consortium: vm.searchItem.consortium,
                jurisdiction: 'ADMINISTRATIVA_CONSORCIOS',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumExpedienteItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchConsortiumExpedienteParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }


        if(angular.isDefined(vm.searchItem.fileType)) {
            Step.query({
                file_type_id: vm.searchItem.fileType.id
            }, function (data) {
                vm.steps = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();
